import { combineReducers } from "redux";
import PopupSlice from "./PopupSlice";
import ChatSpaceSlice from "./ChatSpaceSlice";
import FooterSlice from "./FooterSlice";
import AudioSlice from "./AudioSlice";
import CommentSlice from "./CommentSlice";
import UploadOrUpdateTrackSlice from "./UploadOrUpdateTrackSlice";
import PersonalSlice from "./PersonalSlice";
import CreateUpdateTracklistSlice from "./CreateUpdateTracklistSlice";
import SearchSlice from "./SearchSlice";
import GenreSlice from "./GenreSlice";

const rootReducer = combineReducers({
  popup: PopupSlice,
  chatSpace: ChatSpaceSlice,
  footer: FooterSlice,
  audio: AudioSlice,
  comment: CommentSlice,
  uploadOrUpdateTrack: UploadOrUpdateTrackSlice,
  personal: PersonalSlice,
  createUpdateTracklist: CreateUpdateTracklistSlice,
  search: SearchSlice,
  genres: GenreSlice,
});

export default rootReducer;
